import { create } from 'zustand';
import { fetchP9Samples, type Planet9Sample } from '../lib/planet9';

interface State {
  samples: Planet9Sample[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
  load: (n?: number) => Promise<void>;
}

export const usePlanet9Cloud = create<State>((set, get) => ({
  samples: [],
  loading: false,
  loaded: false,
  error: null,
  load: async (n = 200) => {
    if (get().loaded || get().loading) return;
    set({ loading: true, error: null });
    try {
      const r = await fetchP9Samples(n, 42);
      set({ samples: r.samples, loading: false, loaded: true });
    } catch (e) {
      set({ error: String(e), loading: false });
    }
  },
}));
